<script lang="ts">
	interface Props {
		className?: string;
		strokeWidth?: number;
	}

	let { className = '', strokeWidth = 1 }: Props = $props();
</script>

<div class={className}>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		stroke="currentColor"
		fill="none"
		stroke-width={strokeWidth}
	>
		<path
			d="m18.84375,10.67253c0,-4.31835 -3.05427,-7.82782 -6.8125,-7.82782s-6.8125,3.50947 -6.8125,7.82782c0,6.52319 -3.40625,9.13246 -3.40625,9.13246l20.4375,0s-3.40625,-2.60927 -3.40625,-9.13246z"
		/>
		<path d="m13.99552,20.79918a2.2697,2.2697 0 0 1 -3.92854,0" />
		<ellipse ry="0.5625" rx="0.5625" cy="1.5625" cx="12.03125" />
	</svg>
</div>
